const initAuthSettings = {
  activateNotifications: false,
  activateCarteNotifications: false,
  activateCalendarNotifications: false,

  dashboard: {
    allowAccess: false
  },

  /**
   * allowViewDataBy options:
   * - No access: 0
   * - All: 1
   * - Personal: 10
   * - Partnership: 11
   * - BU: 100
   * - Zone: 101
   * - Backup: 110
   */

  clients: {
    allowAccess: false,
    allowViewDataBy: 0,
    allowUpdateBudgetConfig: false,
    allowUpdateClientSettings: false
  },

  collaborators: {
    allowAccess: false,
    allowConfigCollaborator: false,
    allowViewDataBy: 0,
    allowAccessCPr: false,
    allowAccessPlans: false,
    // drag and drop
    allowDragFromToDo: false,
    allowDragFromWIP: false,
    allowDragFromValidate: false,
    allowDragFromDone: false,
    allowAccessCalendar: false,
    allowValidateVacationRequest: false,
    allowAccessPlanification: false,
    allowAccessFolderCapacity: false,
    allowAccessFinancialState: false,
    allowVerifyBudget: false
  },

  prestations: {
    allowAccess: false,
    allowViewDataBy: 0
  },

  financial: {
    allowAccess: false,

    // financial state
    financialState: {
      allowAccess: false,
      allowViewDataBy: 0
    },
    forfait: {
      allowAccess: false,
      allowLaunchRevision: false
    },
    // croissance
    croissance: {
      allowAccess: false,
      allowViewDataBy: 0,
      allowAccessIN: false,
      allowAccessOUT: false,
      allowAccessRisky: false,
      allowAccessReview: false
    },
    dynamicTable: {
      allowAccess: false,
      allowViewDataBy: 0
    }
  },

  reporting: {
    allowAccess: false,
    production: {
      allowAccess: false,
      allowViewDataBy: 0
    },
    individualDevBe: {
      allowAccess: false,
      allowViewDataBy: 0
    },
    individualDevMa: {
      allowAccess: false,
      allowViewDataBy: 0
    },
    echeance: {
      allowAccess: false,
      allowViewDataBy: 0
    },
    recapBalance: {
      allowAccess: false,
      allowViewDataBy: 0
    },
    calendar: {
      allowAccess: false,
      allowViewDataBy: 0
    },
    timesheet: {
      allowAccess: false,
      allowViewDataBy: 0
    },
    portfolio: {
      allowAccess: false,
      allowViewDataBy: 0
    },
    supervision: {
      allowAccess: false,
      allowViewDataBy: 0
    },
    vacation: {
      allowAccess: false,
      allowViewDataBy: 0
    },
    plans: {
      allowAccess: false,
      allowViewDataBy: 0
    },
    prestations: {
      allowAccess: false,
      allowViewDataBy: 0
    }
  },

  capacityPlanning: {
    allowAccess: false,
    allowViewDataBy: 0
  },

  settings: {
    allowAccess: false,
    allowAccessCategories: false,
    allowAccessTaskTypes: false,
    allowAccessCollaborators: false,
    allowAccessCalendar: false,
    allowAccessModels: false,
    allowAccessUsers: false,
    allowCoefficientsConfig: false,
    allowAccessSynchronization: false,
    allowAccessParameters: false
  },

  timesheet: {
    allowAccess: false,
    allowViewDataBy: 0
  }
};

const initialState = {
  fetching: false,
  fetched: false,
  saving: false,
  saved: false,
  data: {
    synchro: false,
    synchroRole: false,
    synchroEntity: false,
    benchmarkValue: null,
    defaultAuthParameters: {
      superadmin: { ...initAuthSettings },
      admin: { ...initAuthSettings },
      partner: { ...initAuthSettings },
      collaborator: { ...initAuthSettings },
      supervisor: { ...initAuthSettings },
      none: { ...initAuthSettings }
    },
    priceList: {
      "00": 1,
      "01": 1,
      "02": 1,
      "03": 1,
      "04": 1,
      "05": 1,
      "06": 1,
      "07": 1,
      "08": 1,
      "09": 1,
      "10": 1,
      "11": 1,
      "12": 1,
      "13": 1
    }
  }
};

const roles = [
  "none",
  "partner",
  "collaborator",
  "supervisor",
  "superadmin",
  "admin"
];

const updateNestedState = (obj, keys, value) => {
  if (keys.length === 1) {
    return { ...obj, [keys[0]]: value };
  }

  const [firstKey, ...restKeys] = keys;
  return {
    ...obj,
    [firstKey]: updateNestedState(obj[firstKey] || {}, restKeys, value)
  };
};

export const parameterSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "INIT_PARAMETER_SETTINGS": {
      return initialState;
    }
    case "FETCH_PARAMETER_SETTINGS_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_PARAMETER_SETTINGS_FULFILLED": {
      let data = action.payload.data.data;

      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        data: {
          ...data,
          defaultAuthParameters: roles.reduce((result, role) => {
            const params =
              data.defaultAuthParameters &&
              JSON.parse(data.defaultAuthParameters)[role];
            return {
              ...result,
              [role]: params ? params : { ...initAuthSettings }
            };
          }, {}),
          priceList: data.priceList
            ? JSON.parse(data.priceList)
            : {
                "00": 1,
                "01": 1,
                "02": 1,
                "03": 1,
                "04": 1,
                "05": 1,
                "06": 1,
                "07": 1,
                "08": 1,
                "09": 1,
                "10": 1,
                "11": 1,
                "12": 1,
                "13": 1
              }
        }
      };
    }
    case "FETCH_PARAMETER_SETTINGS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        data: [],
        fetching: false,
        error
      };
    }
    case "SET_SYNCHRONIZATION": {
      return {
        ...state,
        data: { ...state.data, synchro: action.synchronization }
      };
    }
    case "SET_SYNCHRONIZATION_ROLE": {
      return {
        ...state,
        data: {
          ...state.data,
          synchroRole: action.synchronizationRole
        }
      };
    }
    case "SET_SYNCHRONIZATION_ENTITY": {
      return {
        ...state,
        data: {
          ...state.data,
          synchroEntity: action.synchronizationEntity
        }
      };
    }
    case "SET_EFFECTIVE_BENCHMARK": {
      return {
        ...state,
        data: {
          ...state.data,
          benchmarkValue: action.benchmarkValue
        }
      };
    }
    case `SAVE_PARAMETER_SETTINGS_PENDING`: {
      return { ...state, saved: false, saving: true };
    }
    case `SAVE_PARAMETER_SETTINGS_FULFILLED`: {
      return {
        ...state,
        saving: false,
        saved: true
      };
    }
    case `SAVE_PARAMETER_SETTINGS_REJECTED`: {
      let error = action.payload;
      switch (error.response.status) {
        case 500:
          error = {
            title: error.response.data.title,
            code: 500
          };
          break;
        default:
          error = {
            title: error.response.data.errors
              ? error.response.data.errors[0].message
              : "An error has occured",
            code: error.response.data.errors
              ? error.response.data.errors[0].code
              : 500
          };
      }
      return {
        ...state,
        saved: false,
        saving: false,
        error
      };
    }

    case "SET_AUTH_PARAMETERS": {
      const { role, path, value } = action.payload;
      const keys = path.split(".");
      return {
        ...state,
        data: {
          ...state.data,
          defaultAuthParameters: {
            ...state.data.defaultAuthParameters,
            [role]: updateNestedState(
              state.data.defaultAuthParameters[role] || {},
              keys,
              value
            )
          }
        }
      };
    }

    case "SET_PRICE_LIST": {
      const { categoryId, price } = action.payload;
      return {
        ...state,
        data: {
          ...state.data,
          priceList: {
            ...state.data.priceList,
            [categoryId]: price
          }
        }
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/parameter-settings.js